import { render, staticRenderFns } from "./RunsList.vue?vue&type=template&id=cbccec66&scoped=true&"
import script from "./RunsList.vue?vue&type=script&lang=js&"
export * from "./RunsList.vue?vue&type=script&lang=js&"
import style0 from "./RunsList.vue?vue&type=style&index=0&id=cbccec66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbccec66",
  null
  
)

export default component.exports